import { FormattedMessage } from 'react-intl';

import { ChannelIcon } from '@/components/ui/channel-icon';
import { Typography } from '@/components/ui/typography';
import { REACH } from '@/types/channels';

import { PublisherSelector } from './publisher-selector';
import { Summary } from './summary';

export function ReachCampaignSection() {
  return (
    <div className="border-fx-neutral-200 mb-4 flex w-[420px] flex-col gap-4 rounded-xl border bg-white p-6 shadow-sm">
      <ChannelIcon
        channelSlug={REACH}
        variant="large"
        className="mx-auto mb-6 h-10"
      />

      <Typography variant="subtitle2" className="p-2">
        <FormattedMessage
          defaultMessage="Channels"
          description="Reach UI: section listing publisher sub-campaigns"
        />
      </Typography>

      <PublisherSelector />

      <Summary />
    </div>
  );
}
